import { DatePickerProps, SelectProps } from 'antd';
import React from 'react';
import { DatePickPcProps } from '../Filter/DatePick/DatePickPc';




export enum FilterTypes {
  ClientArea = 'ClientArea',
  RangePick = 'RangePick',
  Staff = 'Staff',
  StaffBranch = 'StaffBranch',
  FilterSupplier = "FilterSupplier", // 排序值排序
  Select = 'Select',
  Input = 'Input',
  DatePick = 'DatePick',
  ClientType = 'ClientType',
  GoodsCategory = 'GoodsCategory',
  GoodsBrand = 'GoodsBrand',
  GoodsType = 'GoodsType',
  PutAway = 'PutAway',
  SelectGoods = 'SelectGoods',
  SelectWarehouseType = 'SelectWarehouseType',
  Collaborator = 'Collaborator',  // 选择联营商
  SelectWarehouse = 'SelectWarehouse',
  ClientTags = 'ClientTags',
  GoodsTags = 'GoodsTags',
  AccountStatus = 'AccountStatus',
  DateUnitPick = 'DateUnitPick',
  AffiliateCollaborator = "AffiliateCollaborator",  //选择运营商
  DeliverType = "DeliverType",  //发货类型
  Client = "Client",  //选择客户
  Coupon = "Coupon", // 选择优惠券活动
  CouponStatus = "CouponStatus", // 优惠券状态
  IssueMode = "IssueMode", // 发放方式
  Promotion = "Promotion", // 选择满立惠活动
  PromotionWay = "PromotionWay", // 促销方式
  ActivityStatus = "ActivityStatus", // 活动状态
  GoodsPromotion = "GoodsPromotion", // 商品促销
  PromotionType = "PromotionType", // 促销类型
  Sort = "Sort", // 排序值排序
  FilterStore = "FilterStore", // 选择门店
}

type DatePicker = 'day'|'year'|'month'


export interface FilterCommonProps {
  dataIndex: string;
  value?: any
  singleMode?: boolean
  // label?: FilterLabel;
  type: string;
  flex?: React.CSSProperties['flex']; //仅pc支持
  placeholder?:string,
  collaborator_company_id?:number //运营商公司id
  company_id?:number //当前公司id
  startDay?:boolean
  endDay?:boolean
  enabledStartDate?:string // y:年，m:月,d:日。是否限制开始时间，如果不传则不限制，默认3y
  enabledEndDate?:string // y:年，m:月,d:日。是否限制结束时间，如果不传则不限制，默认3y
}
export interface FilterCommonInnerProps {
  // onChangeValues: (dataIndex: string, value: any, source?: any) => void;
  // dataIndex: string;
}
export interface FilterClientAreaProps extends FilterCommonProps {
  type: FilterTypes.ClientArea;  //客户地区
  multiple?: boolean;
  // type: FilterTypes.ClientArea;  //客户地区
}
export interface RangePick extends FilterCommonProps {
  type: FilterTypes.RangePick;  //时间范围
  showTime?: boolean;
}
export interface FilterStaffProps extends FilterCommonProps {
  type: FilterTypes.Staff;  // 供应商
}
export interface FilterSupplierProps extends FilterCommonProps {
  type: FilterTypes.FilterSupplier;  // 业务员
}
export interface FilterStaffBranchProps extends FilterCommonProps {
  type: FilterTypes.StaffBranch;  //业务员部门
}
export interface FilterSelectProps extends FilterCommonProps {
  type: FilterTypes.Select;
  options: Array<{ label: any, value: any }>
}
export interface FilterInputProps extends FilterCommonProps {
  type: FilterTypes.Input;
}
export interface FilterDatePickProps extends FilterCommonProps,Omit<DatePickPcProps,'value' | 'day' | 'picker'>{
  type: FilterTypes.DatePick;
  'startDay'?: boolean
  'endDay'?: boolean
  picker?: DatePicker
  addDay?: string
  startYear?: string // e.g. '3y', '1m', '10d'
  endYear?: string   // e.g. '3y', '1m', '10d'
  allowClear?: boolean
}
export interface FilterClientTypeProps extends FilterCommonProps{
  type: FilterTypes.ClientType   //客户类型
  mode?: undefined | 'multiple' | 'tags';

}

export interface FilterGoodsCategoryProps extends FilterCommonProps {
  type: FilterTypes.GoodsCategory;    // 商品分类
  mode?:'multiple'|'tags';
}

export interface FilterGoodsBrandProps extends FilterCommonProps {
  type: FilterTypes.GoodsBrand;       // 商品品牌
  mode?:'multiple'|'tags';
}

export interface FilterGoodsTypeProps extends FilterCommonProps {
  type: FilterTypes.GoodsType;        // 商品标识
  mode?:'multiple'|'tags';
}

export  interface FilterPutAwayProps extends FilterCommonProps{
  type: FilterTypes.PutAway;        // 上下架
  mode?:'multiple'|'tags';
  allowClear?: boolean;
}

export interface FilterSelectGoodsProps extends FilterCommonProps{
  type: FilterTypes.SelectGoods;    // 选择商品
}

export interface FilterSelectWarehouseTypeProps extends FilterCommonProps{
  type: FilterTypes.SelectWarehouseType;  // 仓库类型
}

export interface FilterCollaboratorProps extends FilterCommonProps{
  type: FilterTypes.Collaborator;   //  选择联营商
}

export interface FilterSelectWarehouseProps extends FilterCommonProps{
  type: FilterTypes.SelectWarehouse;    // 全部仓库
  
}

export interface FilterTagsprops extends FilterCommonProps{
  type: FilterTypes.ClientTags;    // 客户标签
}

export interface FilterGoodsTagsPcprops extends FilterCommonProps{
  type: FilterTypes.GoodsTags;    // 账号状态
}

export interface FilterAccountStatusprops extends FilterCommonProps{
  type: FilterTypes.AccountStatus;    // 账号状态
  mode?: undefined | 'multiple' | 'tags';
}
export interface FilterDateUnitPickProps extends FilterCommonProps,Omit<DatePickPcProps,'value' | 'day' | 'picker'>{
  type: FilterTypes.DateUnitPick
  dataIndexTwo: string
  picker?: DatePicker
}
export interface FilterAffiliateCollaboratorProps extends FilterCommonProps{
  type: FilterTypes.AffiliateCollaborator
  dataIndex: 'collaborator_company_id'  //选择运营商  这个id必须写死，跟接口参数要对应
}


export interface FilterDeliverTypeProps extends FilterCommonProps{
  type: FilterTypes.DeliverType
}
export interface FilterClientProps extends FilterCommonProps{
  type: FilterTypes.Client
}

export interface FilterCouponProps extends FilterCommonProps {
  type: FilterTypes.Coupon
}

export interface FilterCouponStatusProps extends FilterCommonProps {
  type: FilterTypes.CouponStatus,
  mode?: undefined | 'multiple' | 'tags';
}

export interface FilterCouponStatusProps extends FilterCommonProps {
  type: FilterTypes.CouponStatus,
  mode?: undefined | 'multiple' | 'tags';
}

export interface FilterIssueModeProps extends FilterCommonProps {
  type: FilterTypes.IssueMode,
  mode?: undefined | 'multiple' | 'tags';
}

export interface FilterPromotionProps extends FilterCommonProps {
  type: FilterTypes.Promotion,
  mode?: undefined | 'multiple' | 'tags';
}

export interface FilterPromotionWayProps extends FilterCommonProps {
  type: FilterTypes.PromotionWay,
  mode?: undefined | 'multiple' | 'tags';
  allowClear?: boolean
}

export interface FilterActivityStatusProps extends FilterCommonProps {
  type: FilterTypes.ActivityStatus,
  mode?: undefined | 'multiple' | 'tags';
  allowClear?: boolean;
  valueType?: string;
}

export interface FilterGoodsPromotionProps extends FilterCommonProps {
  type: FilterTypes.GoodsPromotion,
  mode?: undefined | 'multiple' | 'tags';
}

export interface FilterPromotionTypeProps extends FilterCommonProps {
  type: FilterTypes.PromotionType,
  mode?: undefined | 'multiple' | 'tags';
  allowClear?: boolean
}

export interface FilterSortProps extends FilterCommonProps {
  type: FilterTypes.Sort
  mode?: undefined | 'multiple' | 'tags';
  allowClear?: boolean
}





export type FilterAll =
  | FilterClientAreaProps
  | RangePick
  | FilterStaffProps
  | FilterSelectProps
  | FilterInputProps
  | FilterStaffBranchProps
  | FilterDatePickProps
  | FilterClientTypeProps
  | FilterGoodsCategoryProps
  | FilterGoodsBrandProps
  | FilterGoodsTypeProps
  | FilterPutAwayProps
  | FilterSelectGoodsProps
  | FilterSelectWarehouseTypeProps
  | FilterCollaboratorProps
  | FilterSelectWarehouseProps
  | FilterTagsprops
  | FilterGoodsTagsPcprops
  | FilterAccountStatusprops
  | FilterDateUnitPickProps
  | FilterAffiliateCollaboratorProps
  | FilterDeliverTypeProps
  | FilterClientProps
  | FilterCouponProps
  | FilterCouponStatusProps
  | FilterIssueModeProps
  | FilterPromotionProps
  | FilterPromotionWayProps
  | FilterActivityStatusProps
  | FilterGoodsPromotionProps
  | FilterPromotionTypeProps
  | FilterSortProps
  | FilterSupplierProps


  export interface FilterProps {
    // filters: FilterAllPc[];
    filters: FilterAll[];
    rowFlex?: number   //行等分数，默认7
    onChangeValues(dataIndex: string, value: any,source?: any): void;
    showFilter?:boolean;
    values?: any;
    isAiChat?: boolean;
  }